import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '@core/services/language.service';
import { Observable } from 'rxjs';

@Injectable()
export class AcceptLanguageHeaderInterceptor implements HttpInterceptor {
	constructor(private readonly languageService: LanguageService) {}
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		req = req.clone({
			setHeaders: { 'Accept-Language': this.languageService.currentLocale },
		});
		return next.handle(req);
	}
}
